import { Group } from './group';
/**
 * The GroupColor transform group data by x channel, and aggregate.
 */
export const GroupColor = (options = {}) => {
    return Group(Object.assign(Object.assign({}, options), { channels: ['color'] }));
};
GroupColor.props = {};
//# sourceMappingURL=groupColor.js.map